import React, { useEffect, useState } from 'react';
import { Card, Typography, Grid, Box, Stack, TextField, Button, FormControl, InputLabel, Select, MenuItem, Badge } from '@mui/material';
import MDButton from 'components/MDButton';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { fetchMembersDetails, fetchWalletLogs, updateWalletMember } from '../../../redux/slices/member';
import { useDispatch } from 'react-redux';
import { fetchWalletReasonList, openSnackbar } from '../../../redux/slices/common';
import NoDataFound from 'common/component/NoDataFound';
import { useSearchParams } from 'react-router-dom';
import { formatTimestampToDateView } from 'utilities/common';
import { formatTimestampToDate24Hours } from 'utilities/common';
import Loader from 'common/Loader';
import { Riple } from 'react-loading-indicators';
import { capitalizeText } from 'utilities/common';


export default function WallerDrawer({ closeModal }) {
  const [formData, setFormData] = useState({
    walletType: "",
    walletAmount: 0,
    walletUpdateAmount: 0,
    walletAdjustmentReason: "",
    walletReasonOther: ""
  })
  const [errors, setErrors] = useState({});
  const { user } = useSelector(state => state.auth);
  const dispatch = useDispatch()
  const { drawerData, drawer } = useSelector(state => state?.modal)
  const { loading = false, logsloading = false } = useSelector(state => state.members) || {};
  const [walletlogs, setWalletlogs] = useState({})
  const [searchParams, setSearchParams] = useSearchParams();
  const { memberDetails = {} } = useSelector(state => state.members) || {};
  const [refundListData, setRefundListData] = useState([]);

  const handleWalletBlock = (type) => {
    setErrors({});
    setFormData((prevData) => ({
      ...prevData,
      walletType: type,
      walletUpdateAmount: "",
      walletAdjustmentReason: "",
      walletReasonOther: ""
    }));
  }

  const handleSubmitWallet = () => {
    if (formData?.walletType === "") {
      setErrors({ walletType: 'Please select a wallet type (Credit or Debit)' });
      return
    }
    if (!formData?.walletUpdateAmount || formData?.walletUpdateAmount <= 0) {
      setErrors({ walletUpdateAmount: 'Wallet amount is required and should be greater than 0.' });
      return;
    }
    if (formData?.walletAdjustmentReason === "") {
      setErrors({ walletAdjustmentReason: 'Wallet Adjustment Reason is Required.' });
      return
    }
    if (formData?.walletAdjustmentReason === 'Other Reason') {
      if (!formData?.walletReasonOther) {
        setErrors({ walletReasonOther: 'Other Reason is Required.' });
        return
      }
    }
    setErrors({}); // Reset errors if valid
    setFormData((prevData) => ({
      ...prevData,
      walletAmount: formData?.walletType === 'credit' ? Number(memberDetails?.walletAmount) + Number(formData?.walletUpdateAmount) : Number(memberDetails?.walletAmount) - Number(formData?.walletUpdateAmount),
    }));
    const amount = formData?.walletType === 'credit' ? Number(memberDetails?.walletAmount) + Number(formData?.walletUpdateAmount) : Number(memberDetails?.walletAmount) - Number(formData?.walletUpdateAmount)
    const payload = {
      "walletAmount": amount.toFixed(2),
      "memberId": drawerData?.memberId,
      "walletAdjustmentReason": formData?.walletAdjustmentReason === 'Other Reason' ? formData?.walletReasonOther : formData?.walletAdjustmentReason,
      "updatedBy": user?.name,
      "walletType": capitalizeText(formData?.walletType)

    }
    if (formData?.walletType === 'debit') {
      if (Number(memberDetails?.walletAmount) - Number(formData?.walletUpdateAmount) < 0) {
        setErrors({ exceed: "Amount exceeds wallet balance." });
        return;
      }
    }
    dispatch(updateWalletMember({ data: payload })).unwrap().then((res) => {
      showError(res?.message, 'success');
      dispatch(fetchMembersDetails(drawerData?.memberId));
      dispatch(fetchWalletLogs({ skip: 0, limit: 3, memberId: drawerData?.memberId })).then((res) => {
        setWalletlogs(res?.payload)
      }).catch((err) => {
      });
      setFormData({
        walletUpdateAmount: 0,
        walletAdjustmentReason: "",
        walletReasonOther: "",
        "walletType": "",

      })

    }).catch((err) => {
      showError(err?.message, 'error');
    });
  }

  const showError = (message, errortype) => {
    if (errortype === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errortype === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };

  useEffect(() => {

    if (drawerData?.memberId) {
      dispatch(fetchWalletLogs({ skip: 0, limit: 3, memberId: drawerData?.memberId })).then((res) => {

        setWalletlogs(res?.payload)
      }).catch((err) => {
      });
    }
  }, [drawerData])


  useEffect(() => {
    dispatch(fetchWalletReasonList()).unwrap().then((res) => {
      setRefundListData(res?.reasons)
    });
  }, [])

  const startTaskHandler = (e, index) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  }

  return (
    <div className='drawer-wallet-balance'>
      <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent='space-between' gap={2} px={3} py={2} style={{ borderBottom: "1px solid #F1F1F1" }}>
        <Typography variant='h6' fontWeight="semibold" color="#656575">Wallet Balance: <span style={{ color: "#2E2E3A" }}>${memberDetails?.walletAmount ? Number(memberDetails?.walletAmount)?.toFixed(2) : 0}</span></Typography>
        <CloseIcon
          fontSize="14px"
          className='cur-pointer'
          onClick={() => closeModal()}
        />
      </Stack>

      <Box p={3} className='drawer-wallet-inner'>
        <Box display="flex" alignItems="start" flexDirection="column" gap={1.25} mb={2}>
          <Stack direction="row" alignItems="center" gap={.75} lineHeight={1}>
            <MDButton
              sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
              type='button'
              variant={formData?.walletType === 'credit' ? 'contained' : 'text'}
              color={formData?.walletType === 'credit' ? 'success' : 'dark'}
              size="small"
              onClick={() => handleWalletBlock("credit")}
            >
              <svg style={{ width: "16px", height: "16px", marginRight: "5px" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z"></path>
              </svg>
              Credit
            </MDButton>
            <MDButton
              sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
              type='button'
              variant={formData?.walletType === 'debit' ? 'contained' : 'text'}
              color={formData?.walletType === 'debit' ? 'success' : 'dark'}
              size="small"
              onClick={() => handleWalletBlock("debit")}
            >
              <svg style={{ width: "14px", height: "16px", marginRight: "5px" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M5 11V13H19V11H5Z"></path>
              </svg>
              Debit
            </MDButton>
          </Stack>
          <p className='error'>{errors?.walletType}</p>
        </Box>
        {/* <span className='error'>{errors?.walletType}</span> */}

        <Box display="flex" flexDirection="column" mb={2}>
          <TextField
            className="form-input"
            type='number'
            name='memo'
            value={formData?.walletUpdateAmount || ''}
            error={Boolean(errors?.walletUpdateAmount || errors?.exceed)} helperText={errors?.walletUpdateAmount || errors?.exceed}
            onChange={(e) => {
              // if (formData?.walletType === 'credit') {
              //   setFormData((prevFormData) => ({
              //     ...prevFormData,
              //     walletAmount: parseInt(walletAmount) + parseInt(e.target.value || 0),
              //   }));
              // } else {
              //   setFormData((prevFormData) => ({
              //     ...prevFormData,
              //     walletAmount: parseInt(walletAmount) - parseInt(e.target.value || 0),
              //   }));
              // }
              setFormData((prevFormData) => ({
                ...prevFormData,
                walletUpdateAmount: e.target.value,
              }));
            }}
            fullWidth
            label="Enter your Value"
          />
        </Box>
        <Box display="flex" flexDirection="column" mb={2}>
          <FormControl fullWidth>
            <InputLabel>Add Reason</InputLabel>
            <Select
              size='large'
              fullWidth
              className='form-select'
              name={`walletAdjustmentReason`}
              value={formData.walletAdjustmentReason}
              onChange={(e) => startTaskHandler(e)}
              label='Add Reason'
              MenuProps={{ className: 'refund-popover drawer-wallet-popover' }}
            >
              {refundListData?.map((option, idx) => (
                <MenuItem key={idx} value={option?.walletReason}>
                  {option?.walletReason}
                </MenuItem>
              ))}
            </Select>
            <p className="error">
              {errors?.walletAdjustmentReason}
            </p>
          </FormControl>

        </Box>
        {
          formData?.walletAdjustmentReason === 'Other Reason' &&
          <Grid item xs={12} sm={12} xl={12} mb={2}>
            <FormControl fullWidth>
              <TextField
                fullWidth
                error={Boolean(errors?.walletReasonOther)}
                helperText={errors?.walletReasonOther}
                className='form-input'
                label='Add other Reason'
                name='walletReasonOther'
                onChange={(e) => { startTaskHandler(e) }}
                multiline
                rows={4}
              />
            </FormControl>
          </Grid>
        }
      
        <MDButton
          sx={{ minWidth: '160px' }}
          type='button'
          variant='contained'
          color='primary'
          onClick={handleSubmitWallet}
          disabled={loading}
          loading={loading}
        >
          Submit
        </MDButton>
      </Box>

      <Box px={3} fullWidth display="flex">
        <span style={{ width: "100%", display: "inline-block", borderBottom: "1px solid #F1F1F1" }}></span>
      </Box>

      <Box p={3} className='activity-logs-inner'>
        <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent='space-between' gap={2} mb={2}>
          <Typography variant='h6' fontWeight="semibold" color="#2E2E3A">Wallet Logs</Typography>

          {!logsloading &&
            walletlogs?.logs?.length !== 0 &&
            <MDButton
              sx={{ minWidth: '90px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
              type='button'
              variant="outlined"
              color="dark"
              size="small"
              onClick={() => { setSearchParams({ roleTab: `walletlogs` }); closeModal() }}
            >
              View All
            </MDButton>
          }
        </Stack>
        <ul>
          {
            logsloading && <div style={{ margin: "auto" }}><Riple color='#3135cc' size='medium' text='' textColor='' /></div>
          }
          {!logsloading &&
            (walletlogs?.logs?.length === 0) ?
            <NoDataFound /> :

            walletlogs?.logs?.map((data) => {

              return (
                <li key={data?._id}>
                  <Box display="flex" flexDirection="column" pb={2} style={{ borderBottom: "1px solid #D0D0DA" }}>
                    <Stack flexDirection='row' alignItems='center' justifyContent='space-between' gap={2}>
                      <Typography style={{ color: "#1E1E24", fontWeight: "600" }}>
                        {formatTimestampToDate24Hours(data?.createdDate)}
                      </Typography>
                      <Badge
                        style={{
                          background: "#cbdffe",
                          padding: "4px 12px",
                          borderRadius: "100px",
                          fontSize: "12px",
                          fontWeight: "500",
                          textTransform: "capitalize"
                        }}
                      >
                        {data?.previousChanges?.walletType ? data?.previousChanges?.walletType : "-"}
                      </Badge>
                    </Stack>
                    <Typography>Updated By: {data?.updatedBy}</Typography>
                  </Box>
                  <Box display="flex" flexDirection="row" gap={2}>
                    <Typography>Previous Amount: <span style={{ color: "#0F0F13", fontWeight: "600" }}>${data?.previousChanges?.walletAmount ? Number(data?.previousChanges?.walletAmount).toFixed(2) : 0}</span></Typography>
                    <Typography>New Amount: <span style={{ color: "#0F0F13", fontWeight: "600" }}>${data?.newChanges?.walletAmount ? Number(data?.newChanges?.walletAmount || 0).toFixed(2)
                      : 0}</span></Typography>
                  </Box>
                  <Box display="flex">
                    <Typography>{data?.newChanges?.walletAdjustmentReason}</Typography>
                  </Box>
                </li>
              )
            })
          }

        </ul>
      </Box>

    </div>
  )
}
